
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"41","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8963EA","d":"M6 13.617C6 12.725 6.77 12 7.72 12h16.856c1.346 0 2.171 1.386 1.465 2.463l-.176.269a1.75 1.75 0 01-1.466.768H7.721C6.77 15.502 6 14.778 6 13.886v-.27z"}}),_c('path',{attrs:{"fill":"#C4B1F4","d":"M6 18.651c0-.966.794-1.75 1.774-1.75h13.949c1.393 0 2.242 1.512 1.504 2.678a1.778 1.778 0 01-1.504.822H7.773A1.76 1.76 0 016 18.651z"}}),_c('path',{attrs:{"fill":"#E7E0FB","d":"M6 24.252c0-.967.786-1.75 1.755-1.75h9.786c1.362 0 2.205 1.478 1.509 2.645-.317.53-.89.855-1.509.855H7.755c-.97 0-1.755-.784-1.755-1.75z"}}),_c('path',{attrs:{"fill":"#8963EA","d":"M21.4 27.097l.022 3.917c.003.446.468.728.85.515l3.556-1.981a.585.585 0 00.228-.232l7.871-14.536a.599.599 0 00-.224-.803l-3.347-1.902a.567.567 0 00-.777.223L21.477 26.8a.614.614 0 00-.077.297z"}})])
          )
        }
      }
    